<template>
   <div label="模板统计" name="dataDrawing" v-loading="loadingAll">
      <div class="padding15-tb">
        <el-form size="small" label-width="100px">
          <el-row :gutter="24">
            <el-col :span="7" v-if="this.$partB()">
              <el-form-item label="公司">
                <el-select v-model="dataDrawing.companyName" :multiple-limit=5 remote :remote-method="searchCompanyList" filterable multiple collapse-tags placeholder="最多展示五家公司数据" style="width: 100%;">
                  <el-option
                    v-for="item in companyNameList"
                    :key="item.id"
                    :label="item.companyName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="时间">
                <el-date-picker style="width: 100%;"
                  v-model="dataDrawing.startTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="至">
                <el-date-picker style="width: 100%;"
                  v-model="dataDrawing.endTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-button type="primary" @click="getDataList" size="small" plain> <i class="fa fa-search"></i>搜索</el-button>
              <el-button @click="resetBtn" size="small">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="page">
        <div class="index-section m-t-24">
          <!-- <h1 style="text-align: center;">最多展示五家公司数据</h1> -->
          <!-- 第一行 -->
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="panel">
                <div class="panel-header">
                  <i class="el-icon-tickets">&nbsp;导入案件量图表</i>
                  <div class="fr send-options">
                    <el-radio-group v-model="caseImportDataType" @change="changeCaseImportDataType">
                      <el-radio-button label="day">日</el-radio-button>
                      <el-radio-button label="week">周</el-radio-button>
                      <el-radio-button label="month">月</el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <div class="panel-content" v-if="this.caseImportData.rows.length !== 0">
                  <ve-line :data="caseImportData" v-loading="loading"></ve-line>
                </div>
                <div class="panel-content" v-else>
                  <p style="text-align: center;">暂无数据</p>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="panel">
                <div class="panel-header">
                  <i class="el-icon-tickets">&nbsp;回收率图表</i>
                  <div class="fr send-options">
                    <el-radio-group v-model="caseRecoveryRateType" @change="changeCaseRecoveryRateType">
                      <el-radio-button label="day">日</el-radio-button>
                      <el-radio-button label="week">周</el-radio-button>
                      <el-radio-button label="month">月</el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <div class="panel-content" v-if="this.caseRecoveryRate.rows.length !== 0">
                  <ve-line :data="caseRecoveryRate" v-loading="loading1" :settings="recoveryRateSettings"></ve-line>
                </div>
                <div class="panel-content" v-else>
                  <p style="text-align: center;">暂无数据</p>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 第二行 -->
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="panel">
                <div class="panel-header">
                  <i class="el-icon-tickets">&nbsp;回复率图表</i>
                  <div class="fr send-options">
                    <el-radio-group v-model="caseResponseRatesType" @change="changeCaseResponseRatesType">
                      <el-radio-button label="day">日</el-radio-button>
                      <el-radio-button label="week">周</el-radio-button>
                      <el-radio-button label="month">月</el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <div class="panel-content" v-if="this.caseResponseRates.rows.length !== 0">
                  <ve-line :data="caseResponseRates" v-loading="loading2" :settings="responseRatesSettings"></ve-line>
                </div>
                <div class="panel-content" v-else>
                  <p style="text-align: center;">暂无数据</p>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="panel">
                <div class="panel-header">
                  <i class="el-icon-tickets">&nbsp;本人接听率图表</i>
                  <div class="fr send-options">
                    <el-radio-group v-model="personalAnswerRatesType" @change="changePersonalAnswerRatesType">
                      <el-radio-button label="day">日</el-radio-button>
                      <el-radio-button label="week">周</el-radio-button>
                      <el-radio-button label="month">月</el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <div class="panel-content" v-if="this.personalAnswerRates.rows.length !== 0">
                  <ve-line :data="personalAnswerRates" v-loading="loading3" :settings="personalAnswerSettings"></ve-line>
                </div>
                <div class="panel-content" v-else>
                  <p style="text-align: center;">暂无数据</p>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 第三行 -->
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="panel">
                <div class="panel-header">
                  <i class="el-icon-tickets">&nbsp;本人可联率图表</i>
                  <div class="fr send-options">
                    <el-radio-group v-model="personalContactRatesType" @change="changePersonalContactRatesType">
                      <el-radio-button label="day">日</el-radio-button>
                      <el-radio-button label="week">周</el-radio-button>
                      <el-radio-button label="month">月</el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <div class="panel-content" v-if="this.personalContactRates.rows.length !== 0">
                  <ve-line :data="personalContactRates" v-loading="loading4" :settings="personalContactSettings"></ve-line>
                </div>
                <div class="panel-content" v-else>
                  <p style="text-align: center;">暂无数据</p>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="panel">
                <div class="panel-header">
                  <i class="el-icon-tickets">&nbsp;件均短信发送数图表</i>
                  <div class="fr send-options">
                    <el-radio-group v-model="msgCountRatesType" @change="changeMsgCountRatesType">
                      <el-radio-button label="day">日</el-radio-button>
                      <el-radio-button label="week">周</el-radio-button>
                      <el-radio-button label="month">月</el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <div class="panel-content" v-if="this.msgCountRates.rows.length !== 0">
                  <ve-line :data="msgCountRates" v-loading="loading5"></ve-line>
                </div>
                <div class="panel-content" v-else>
                  <p style="text-align: center;">暂无数据</p>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 第三行 -->
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="panel">
                <div class="panel-header">
                  <i class="el-icon-tickets">&nbsp;件均语音发送数图表</i>
                  <div class="fr send-options">
                    <el-radio-group v-model="ivrCountRatesType" @change="changeIvrCountRatesType">
                      <el-radio-button label="day">日</el-radio-button>
                      <el-radio-button label="week">周</el-radio-button>
                      <el-radio-button label="month">月</el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <div class="panel-content" v-if="this.ivrCountRates.rows.length !== 0">
                  <ve-line :data="ivrCountRates" v-loading="loading6"></ve-line>
                </div>
                <div class="panel-content" v-else>
                  <p style="text-align: center;">暂无数据</p>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="panel">
                <div class="panel-header">
                  <i class="el-icon-tickets">&nbsp;{{this.caseDifficultyScoreCompanyName}}案件评分图表</i>
                  <div class="fr send-options">
                    <el-radio-group v-model="caseDifficultyScoreType" @change="changeCaseDifficultyScoreType">
                      <el-radio-button label="day">日</el-radio-button>
                      <el-radio-button label="week">周</el-radio-button>
                      <el-radio-button label="month">月</el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <div class="panel-content" v-if="this.caseDifficultyScore.rows.length !== 0">
                  <ve-histogram :data="caseDifficultyScore" :settings="chartSettings" v-loading="loading7"></ve-histogram>
                </div>
                <div class="panel-content" v-else>
                  <p style="text-align: center;">暂无数据</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
   </div>
</template>
<script>
import VeLine from 'v-charts/lib/line.common';
import VeRing from 'v-charts/lib/ring.common';
import VeHistogram from 'v-charts/lib/histogram.common';

export default {
  data() {
    return {
      recoveryRateSettings: {
        axisSite: { right: [] },
        yAxisType: ['', 'percent']
      },
      responseRatesSettings: {
        axisSite: { right: [] },
        yAxisType: ['', 'percent']
      },
      personalAnswerSettings: {
        axisSite: { right: [] },
        yAxisType: ['', 'percent']
      },
      personalContactSettings: {
        axisSite: { right: [] },
        yAxisType: ['', 'percent']
      },
      msgCountSettings: {
        axisSite: { right: [] },
        yAxisType: ['', 'percent']
      },
      ivrCountSettings: {
        axisSite: { right: [] },
        yAxisType: ['', 'percent']
      },
      caseImportData: {
        columns: [],
        rows: []
      },
      caseRecoveryRate: {
        columns: [],
        rows: []
      },
      caseResponseRates: {
        columns: [],
        rows: []
      },
      personalAnswerRates: {
        columns: [],
        rows: []
      },
      personalContactRates: {
        columns: [],
        rows: []
      },
      msgCountRates: {
        columns: [],
        rows: []
      },
      ivrCountRates: {
        columns: [],
        rows: []
      },
      dataDrawing: {
        companyName: [],
        startTime: '',
        endTime: ''
      },
      companyNameList: [],
      caseDifficultyScore: {
        columns: ['time', 'difficultyScore', 'difficultyScoreMin', 'difficultyScoreMiddle', 'difficultyScoreMax'],
        rows: []
      },
      chartSettings: {
        showLine: ['difficultyScore'],
        axisSite: { right: ['difficultyScoreMin', 'difficultyScoreMiddle', 'difficultyScoreMax'] },
        yAxisType: ['', 'percent'],
        labelMap: {
          'difficultyScore': '平均评分',
          'difficultyScoreMin': '0～15',
          'difficultyScoreMiddle': '15～85',
          'difficultyScoreMax': '85～100'
        },
        legendName: {
          '平均评分': '平均评分',
          '0～15': '0～15',
          '15～85': '15～85',
          '85～100': '85～100'
        }
      },
      caseDifficultyScoreCompanyName: null,
      companyColumns: null,
      axisSiteAll: null,
      loading: false,
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      loading5: false,
      loading6: false,
      loading7: false,
      caseImportDataType: 'day',
      caseRecoveryRateType: 'day',
      caseResponseRatesType: 'day',
      personalAnswerRatesType: 'day',
      personalContactRatesType: 'day',
      msgCountRatesType: 'day',
      ivrCountRatesType: 'day',
      caseDifficultyScoreType: 'day',
      loadingAll: false
    };
  },
  mounted() {
    this.$router.push({ path: `${this.$route.path}?report=数据图表` });
    this.dataDrawing.companyName = [];
    this.dataDrawing.startTime = '';
    this.dataDrawing.endTime = '';
    this.getTime();
    this.getCompanyAll();
  },
  methods: {
    getTime() {
      const day = new Date();
      day.setTime(day.getTime() - (24 * 60 * 60 * 1000 * 10));
      const s1 = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()} 00:00:00`;
      this.dataDrawing.startTime = s1;
    },
    // 重置
    resetBtn() {
      console.warn('重置');
      this.dataDrawing.companyName = [];
      this.dataDrawing.startTime = '';
      this.dataDrawing.endTime = '';
    },
    // 搜索
    getDataList() {
      if (this.dataDrawing.companyName.length > 0) {
        const companyList = [];
        this.companyNameList.forEach((item) => {
          this.dataDrawing.companyName.forEach((cc) => {
            if (item.id === cc && companyList.length < 5) {
              companyList.push(item.companyName);
            }
          });
        });
        const list = ['time'];
        this.companyColumns = list.concat(companyList);
        this.axisSiteAll = companyList;
      } else {
        const companyList = [];
        this.companyNameList.forEach((item) => {
          if (companyList.length < 5) {
            companyList.push(item.companyName);
          }
        });
        const list = ['time'];
        this.companyColumns = list.concat(companyList);
        this.axisSiteAll = companyList;
      }
      this.getData();
    },
    // 公司下拉框
    getCompanyAll() {
      this.loadingAll = true;
      this.$ajax({
        url: '/report/getCompanyList',
        params: { 'val': '' }
      }).then((res) => {
        this.companyNameList = res.data;
        const companyList = [];
        this.companyNameList.forEach((item) => {
          if (companyList.length < 5) {
            companyList.push(item.companyName);
          }
        });
        const list = ['time'];
        this.companyColumns = list.concat(companyList);
        this.axisSiteAll = companyList;
        this.getData();
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    getData() {
      this.getCaseImportCount();
      this.getCaseRecoveryRate();
      this.getCaseResponseRate();
      this.getPersonalAnswerRate();
      this.getPersonalContactRate();
      this.getMsgCountRate();
      this.getIvrCountRate();
      this.getCaseDifficultyScore();
      this.loadingAll = false;
    },
    searchCompanyList(val) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: '/report/getCompanyList',
          params: { 'val': val }
        }).then((res) => {
          this.companyNameList = res.data;
          resolve();
        }).catch((err) => {
          reject(err);
        });
      });
    },
    changeCaseImportDataType() {
      this.getCaseImportCount();
    },
    changeCaseRecoveryRateType() {
      this.getCaseRecoveryRate();
    },
    changeCaseResponseRatesType() {
      this.getCaseResponseRate();
    },
    changePersonalAnswerRatesType() {
      this.getPersonalAnswerRate();
    },
    changePersonalContactRatesType() {
      this.getPersonalContactRate();
    },
    changeMsgCountRatesType() {
      this.getMsgCountRate();
    },
    changeIvrCountRatesType() {
      this.getIvrCountRate();
    },
    changeCaseDifficultyScoreType() {
      this.getCaseDifficultyScore();
    },
    // 获取案件导入量数据
    getCaseImportCount() {
      this.loading = true;
      this.$ajax({
        url: '/report/getCaseImportCount',
        data: { 'companyName': this.dataDrawing.companyName, 'startTime': this.dataDrawing.startTime, 'endTime': this.dataDrawing.endTime, 'type': this.caseImportDataType }
      }).then((res) => {
        this.caseImportData.columns = this.companyColumns;
        const datas = res.data.respList;
        const chartDatas = [];
        datas.forEach((item) => {
          if (this.caseImportDataType === 'day') {
            const exist = chartDatas.filter(t => t.time === item.time);
            if (exist.length > 0) {
              const obj = exist[0];
              obj[item.companyName] = item.count;
            } else {
              const obj = {};
              obj.time = item.time;
              obj[item.companyName] = item.count;
              chartDatas.push(obj);
            }
          } else if (this.caseImportDataType === 'month') {
            const exist = chartDatas.filter(t => t.time === item.monthTime);
            if (exist.length > 0) {
              const obj = exist[0];
              obj[item.companyName] = item.count;
            } else {
              const obj = {};
              obj.time = item.monthTime;
              obj[item.companyName] = item.count;
              chartDatas.push(obj);
            }
          } else if (this.caseImportDataType === 'week') {
            const exist = chartDatas.filter(t => t.time === item.weekTime);
            if (exist.length > 0) {
              const obj = exist[0];
              obj[item.companyName] = item.count;
            } else {
              const obj = {};
              obj.time = item.weekTime;
              obj[item.companyName] = item.count;
              chartDatas.push(obj);
            }
          }
        });
        this.caseImportData.rows = chartDatas;
        this.loading = false;
      });
    },
    // 获取回收率图表数据
    getCaseRecoveryRate() {
      this.loading1 = true;
      this.$ajax({
        url: '/report/getCaseRecoveryRate',
        data: { 'companyName': this.dataDrawing.companyName, 'startTime': this.dataDrawing.startTime, 'endTime': this.dataDrawing.endTime, 'type': this.caseRecoveryRateType }
      }).then((res) => {
        this.caseRecoveryRate.columns = this.companyColumns;
        this.recoveryRateSettings.axisSite.right = this.axisSiteAll;
        // 赋值回收率图表图表数据
        const arr = this.getList(res.data.respList, this.caseRecoveryRateType);
        this.caseRecoveryRate.rows = arr;
        this.loading1 = false;
      });
    },
    // 获取回复率图表数据
    getCaseResponseRate() {
      this.loading2 = true;
      this.$ajax({
        url: '/report/getCaseResponseRate',
        data: { 'companyName': this.dataDrawing.companyName, 'startTime': this.dataDrawing.startTime, 'endTime': this.dataDrawing.endTime, 'type': this.caseResponseRatesType }
      }).then((res) => {
        this.caseResponseRates.columns = this.companyColumns;
        this.responseRatesSettings.axisSite.right = this.axisSiteAll;
        // 赋值回复率图表图表数据
        const arr = this.getList(res.data.respList, this.caseResponseRatesType);
        this.caseResponseRates.rows = arr;
        this.loading2 = false;
      });
    },
    // 获取本人接听率图表数据
    getPersonalAnswerRate() {
      this.loading3 = true;
      this.$ajax({
        url: '/report/getPersonalAnswerRate',
        data: { 'companyName': this.dataDrawing.companyName, 'startTime': this.dataDrawing.startTime, 'endTime': this.dataDrawing.endTime, 'type': this.personalAnswerRatesType }
      }).then((res) => {
        this.personalAnswerRates.columns = this.companyColumns;
        this.personalAnswerSettings.axisSite.right = this.axisSiteAll;
        // 赋值本人接听率图表图表数据
        const arr = this.getList(res.data.respList, this.personalAnswerRatesType);
        this.personalAnswerRates.rows = arr;
        this.loading3 = false;
      });
    },
    // 获取本人可联率图表数据
    getPersonalContactRate() {
      this.loading4 = true;
      this.$ajax({
        url: '/report/getPersonalContactRate',
        data: { 'companyName': this.dataDrawing.companyName, 'startTime': this.dataDrawing.startTime, 'endTime': this.dataDrawing.endTime, 'type': this.personalContactRatesType }
      }).then((res) => {
        this.personalContactRates.columns = this.companyColumns;
        this.personalContactSettings.axisSite.right = this.axisSiteAll;
        // 赋值本人可联率图表图表数据
        const arr = this.getList(res.data.respList, this.personalContactRatesType);
        this.personalContactRates.rows = arr;
        this.loading4 = false;
      });
    },
    // 获取件均短信发送图表数据
    getMsgCountRate() {
      this.loading5 = true;
      this.$ajax({
        url: '/report/getMsgCountRate',
        data: { 'companyName': this.dataDrawing.companyName, 'startTime': this.dataDrawing.startTime, 'endTime': this.dataDrawing.endTime, 'type': this.msgCountRatesType }
      }).then((res) => {
        this.msgCountRates.columns = this.companyColumns;
        // 赋值短信发送图表数据
        const arr = this.getList(res.data.respList, this.msgCountRatesType);
        this.msgCountRates.rows = arr;
        this.loading5 = false;
      });
    },
    // 获取件均语音发送图表数据
    getIvrCountRate() {
      this.loading6 = true;
      this.$ajax({
        url: '/report/getIvrCountRate',
        data: { 'companyName': this.dataDrawing.companyName, 'startTime': this.dataDrawing.startTime, 'endTime': this.dataDrawing.endTime, 'type': this.ivrCountRatesType }
      }).then((res) => {
        this.ivrCountRates.columns = this.companyColumns;
        // 赋值语音发送图表数据
        const arr = this.getList(res.data.respList, this.ivrCountRatesType);
        this.ivrCountRates.rows = arr;
        this.loading6 = false;
      });
    },
    getList(datas, type) {
      const chartDatas = [];
      datas.forEach((item) => {
        if (type === 'day') {
          const exist = chartDatas.filter(t => t.time === item.time);
          if (exist.length > 0) {
            const obj = exist[0];
            obj[item.companyName] = item.caseRecoveryRate;
          } else {
            const obj = {};
            obj.time = item.time;
            obj[item.companyName] = item.caseRecoveryRate;
            chartDatas.push(obj);
          }
        } else if (type === 'month') {
          const exist = chartDatas.filter(t => t.time === item.monthTime);
          if (exist.length > 0) {
            const obj = exist[0];
            obj[item.companyName] = item.caseRecoveryRate;
          } else {
            const obj = {};
            obj.time = item.monthTime;
            obj[item.companyName] = item.caseRecoveryRate;
            chartDatas.push(obj);
          }
        } else if (type === 'week') {
          const exist = chartDatas.filter(t => t.time === item.weekTime);
          if (exist.length > 0) {
            const obj = exist[0];
            obj[item.companyName] = item.caseRecoveryRate;
          } else {
            const obj = {};
            obj.time = item.weekTime;
            obj[item.companyName] = item.caseRecoveryRate;
            chartDatas.push(obj);
          }
        }
      });
      return chartDatas;
    },
    // 获取评分图表数据
    getCaseDifficultyScore() {
      this.loading7 = true;
      this.$ajax({
        url: '/report/caseDifficultyScoreData',
        data: { 'companyName': this.dataDrawing.companyName, 'startTime': this.dataDrawing.startTime, 'endTime': this.dataDrawing.endTime, 'type': this.caseDifficultyScoreType }
      }).then((res) => {
        this.caseDifficultyScore.rows = res.data;
        this.caseDifficultyScoreCompanyName = res.data[0].companyName;
        this.loading7 = false;
      });
    }
  },
  components: {
    VeLine, VeRing, VeHistogram
  }
};
</script>




// WEBPACK FOOTER //
// src/page/main/collection/report/dataDrawingList.vue